import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=0bda56a2"
import script from "./Breadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=0bda56a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports